import {connect} from 'react-redux';
import {TransilluminatorControlsModal as Component} from './TransilluminatorControls';
import {
  showModal,
  setGelInTransilluminator,
  turnOnTransilluminator,
  transilluminatorGelExmined,
  setNoteBookSection
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    open: state.notebook.protocolSection.scene.apparatus.transilluminator[0].open,
    on: state.notebook.protocolSection.scene.apparatus.transilluminator[0].on,
    containsGel: state.notebook.protocolSection.scene.apparatus.transilluminator[0].containsGel,
    gelExamined: state.notebook.protocolSection.scene.apparatus.transilluminator[0].gelExamined,
    gelOrientation: state.notebook.protocolSection.scene.apparatus.transilluminator[0].gelOrientation,
    display:  state.notebook.protocolSection.scene.modal.display,
    notebookExpanded: !state.notebook.notebookCollapsed,
    interactionProps: {
      solutions: state.notebook.protocolSection.scene.apparatus.solutions,
      agaroseGel: state.notebook.protocolSection.scene.apparatus.agaroseGel
    },
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) =>{
      dispatch(showModal(data))
    },
    setGelInTransilluminator: (data) => {
      dispatch(setGelInTransilluminator(data))
    },
    turnOnTransilluminator: (data) => {
      dispatch(turnOnTransilluminator(data))
    },
    transilluminatorGelExmined: (data) => {
      dispatch(transilluminatorGelExmined(data))
    },
    setNoteBookSection: (data) => {
      dispatch(setNoteBookSection(data))
    }
  }
}

export const TransilluminatorControlsModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
